import { useState } from "react";
import formStyle from "../form.module.css";
import { ContactInformation } from "../../../../sdkStructs";

interface Props {
  formDefault?: ContactInformation;
  submit: (data: ContactInformation) => void;
}

const emptyForm: ContactInformation = {
  Name: "",
  PhoneNumber: "",
  Email: "",
  Company: "",
};

// !IMPORTANT: metadata usually refers to "contact information", other information is referred to as "pentest information"
function ContactInformationForm({ formDefault, submit }: Readonly<Props>) {
  const [formState, setFormState] = useState<ContactInformation>(formDefault ?? emptyForm);

  function preventedSubmit(event: React.FormEvent, data: ContactInformation) {
    event.preventDefault();
    submit(data);
  }

  return (
    <form onSubmit={(event: React.FormEvent) => preventedSubmit(event, formState)} className={formStyle.formWrapper}>
      <div className={formStyle.fieldsWrapper}>
        <h5 className={formStyle.firstLabel + " " + formStyle.requiredField}>{"Contact Name"}</h5>
        <input
          className={formStyle.inputField}
          type={"text"}
          value={formState.Name}
          required
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setFormState({ ...formState, Name: e.currentTarget.value });
          }}
        />

        <h5 className={formStyle.label + " " + formStyle.requiredField}>{"Phone"}</h5>
        <input
          className={formStyle.inputField}
          type={"tel"}
          //pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
          value={formState.PhoneNumber}
          required
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setFormState({ ...formState, PhoneNumber: e.currentTarget.value });
          }}
        />

        <h5 className={formStyle.label + " " + formStyle.requiredField}>{"Email"}</h5>
        <input
          className={formStyle.inputField}
          type={"email"}
          value={formState.Email}
          required
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setFormState({
              ...formState,
              Email: e.currentTarget.value,
            });
          }}
        />

        <h5 className={formStyle.label + " " + formStyle.requiredField}>{"Pentest Company"}</h5>
        <input
          className={formStyle.inputField}
          type={"text"}
          value={formState.Company}
          required
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            setFormState({
              ...formState,
              Company: e.currentTarget.value,
            });
          }}
        />
      </div>

      <button type="submit" className={formStyle.submitButton}>
        Submit
      </button>
    </form>
  );
}

export default ContactInformationForm;
